
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTidalWaterLevelInformation as ObiTidalWaterLevelInformationElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-tidal-water-level-information.js';
 
 
 

 
 export const ObiTidalWaterLevelInformation = createComponent({
   react: React,
   tagName: 'obi-tidal-water-level-information',
   elementClass: ObiTidalWaterLevelInformationElement,
   events: {
     
   }
  });
 
 